import PropTypes from 'prop-types'
import { LuCircleArrowRight, LuExternalLink } from 'react-icons/lu'
import { Link } from 'wouter'

export default function DashboardComp({ cards }) {
  return (
    <div className="grid grid-cols-1 gap-8 mt-8 xl:mt-12 xl:gap-12 md:grid-cols-2 xl:grid-cols-3">
      {cards.map((card, index) => {
        const isExternal = card?.link?.startsWith('http')
        const linkClass =
          'inline-flex p-2 text-[#006F53] capitalize transition-colors duration-200 transform bg-[#e8f5f0] rounded-full dark:bg-[#006F53] dark:text-white hover:bg-[#c8e6da] dark:hover:bg-[#005540] focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-[#006F53]'

        return (
          <div
            key={index}
            className="flex flex-col p-8 space-y-3 border-2 border-[#006F53] dark:border-[#4a9e7e] rounded-xl hover:shadow-md transition-shadow duration-200"
          >
            {/* Icona */}
            <span className="inline-block text-[#006F53] dark:text-[#4a9e7e]">
              {card?.icon}
            </span>

            {/* Títol */}
            <h1 className="text-xl font-semibold text-gray-700 capitalize dark:text-white">
              {card?.title}
            </h1>

            {/* Descripció */}
            <p className="text-gray-500 dark:text-gray-300 grow">
              {card?.description}
            </p>

            {/* Enllaç: intern o extern */}
            <div className="mt-auto pt-2">
              {isExternal ? (
                <a
                  href={card?.link}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className={linkClass}
                >
                  <LuExternalLink size={28} />
                </a>
              ) : (
                <Link href={card?.link} className={linkClass}>
                  <LuCircleArrowRight size={28} />
                </Link>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

DashboardComp.propTypes = {
  cards: PropTypes.array
}
